// extracted by mini-css-extract-plugin
module.exports = {"logo":"ShopLogo2-logo-c51f"};